import clsx from 'clsx';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useRef } from 'react';

import { ReactComponent as CharterSgIcon } from 'icons/charter-sg-dark-blue-icon.svg';
import { ReactComponent as ChevronDown } from 'icons/chevron-down.svg';
import { isDisabledDurationRent } from 'utils/functionality';

const SelectFieldCharterPricing = ({
  style,
  className,
  id,
  label,
  data = [],
  selectedPrice,
  onSelectPrice,
  placeholder = '',
  disable,
  startDate,
  starHour,
}) => {
  const dropdownRef = useRef(null);

  const [isShowDropdown, setIsShowDropdown] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsShowDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsShowDropdown(!isShowDropdown);
  };

  const clickHandler = (price) => {
    onSelectPrice(price);
    setIsShowDropdown(!isShowDropdown);
  };

  return (
    <div className={clsx('select-field-charter-pricing', className)} style={style} ref={dropdownRef}>
      {label && (
        <label htmlFor={id} className="select-field-charter-pricing__label">
          {label}
        </label>
      )}
      <div className={clsx('select-field-charter-pricing__field', disable ? 'disable' : '')} onClick={toggleDropdown}>
        <div className="content-price">
          <CharterSgIcon />
          <p>{selectedPrice?.duration ? `${selectedPrice.label} (${selectedPrice.duration} Jam)` : placeholder}</p>
          <ChevronDown className={clsx('content-price__chevron', isShowDropdown ? 'up' : 'down')} />
        </div>
      </div>

      {isShowDropdown && (
        <div className="select-field-charter-pricing__dropdown">
          <ul className="list-container">
            {data && data.length !== 0 ? (
              data.map((pri, index) => (
                <li
                  key={pri.price}
                  className={clsx(
                    'list-item-price',
                    isDisabledDurationRent(pri.duration, startDate, starHour) ? 'disabled' : '',
                  )}
                  style={{ borderTop: index === 0 ? 'none' : '1px solid #E0E0E0' }}
                >
                  <button onClick={() => clickHandler(pri)} className="wrapper-btn">
                    <CharterSgIcon />
                    <p>{`${pri.label} (${pri.duration} Jam)`}</p>
                  </button>
                </li>
              ))
            ) : (
              <li>No Data Found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SelectFieldCharterPricing;
